module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isPc ? 'signup' : ''
  }, [_c('IconSwitch', {
    attrs: {
      "type": 'qrcode'
    }
  }), _vm._v(" "), _c('Icon'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Inputs', {
    attrs: {
      "type": 'account'
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('el-collapse-transition', [(_vm.exist) ? _c('Warn', {
    attrs: {
      "type": 'accountexist',
      "data": _vm.account
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    attrs: {
      "type": 'continue',
      "data": _vm.account
    },
    on: {
      "accountExist": _vm.accountExist,
      "openErrorTip": _vm.openErrorTip
    }
  }), _vm._v(" "), (!_vm.isGenericVersion) ? _c('Foot', {
    staticStyle: {
      "margin-bottom": "44px"
    },
    attrs: {
      "type": 'Already using crait'
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71402483"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/login/Signup.vue
// module id = 785
// module chunks = 1